import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=7e314f3c&scoped=true"
import script from "./goodsDetail.vue?vue&type=script&lang=js"
export * from "./goodsDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=7e314f3c&prod&lang=less&scoped=true"
import style1 from "./goodsDetail.vue?vue&type=style&index=1&id=7e314f3c&prod&lang=less&scoped=true"
import style2 from "./goodsDetail.vue?vue&type=style&index=2&id=7e314f3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e314f3c",
  null
  
)

export default component.exports